import { useEffect, useState } from 'react';

import type { CountryCode } from '@/graphql/saleor/api';
import type { ValidationRules } from '@/providers/ConfigProvider';
import { useConfigProvider } from '@/providers/ConfigProvider';

export const useAddressValidationRules = () => {
  const [rules, setRules] = useState<ValidationRules | null>(null);
  const { getValidationRules } = useConfigProvider();

  const useValidationRulesUpdate = (country: CountryCode) => {
    useEffect(() => {
      if (!country) return;
      (async () => {
        setRules(null);
        const rules = await getValidationRules(country);
        setRules(rules);
      })();
    }, [country]);
  };

  return { rules, useValidationRulesUpdate };
};
